'use client';

import React, {useCallback} from 'react';
import {observer} from 'mobx-react';
import {useClpPurchaseContext} from '../../context/clp-purchase-context.react-component';
import classNames from 'classnames';

import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {EnableCouponInputModeButton} from '../redeem-coupon/redeem-coupon.react-component';
import {GiftThisCourse} from '../gift-this-course';
import {MarketplaceSocialShareButton} from '../share/marketplace-social-share-button.react-component';
import styles from './clp-secondary-actions.module.scss';
import {MODES} from '../redeem-coupon/constants';

export interface ClpSecondaryActionProps {
    className?: string;
}

/**
 * ClpSecondaryActions component renders secondary action buttons for course landing page
 * including social share, gift course, and coupon input mode buttons.
 */
export const ClpSecondaryActions = observer(function ClpSecondaryActions({
    className,
}: ClpSecondaryActionProps) {
    const course = useClpCourse();
    const {couponStore} = useClpPurchaseContext();

    const handleEnterInputMode = useCallback(() => {
        couponStore.enterInputMode();
    }, [couponStore]);

    // Only disable the coupon button when in PENDING mode (loading)
    // Allow clicking when in INPUT mode since user might want to collapse/expand the form
    const isCouponFormDisabled = couponStore.currentMode === MODES.PENDING;

    return (
        <div className={classNames(styles['secondary-action-container'], className)}>
            <MarketplaceSocialShareButton
                shareableObject={{
                    ...course,
                    is_private: false,
                }}
                sourceUrl={course.urlCourseLanding || ''}
                context="clp"
                className="ud-link-underline ud-link-neutral"
                load={() =>
                    import('../share/marketplace-social-share-content.react-component').then(
                        ({MarketplaceSocialShareContent}) => ({
                            default: MarketplaceSocialShareContent,
                        }),
                    )
                }
            />
            <GiftThisCourse />
            <EnableCouponInputModeButton
                onEnterInputMode={handleEnterInputMode}
                enableCouponInputModeButtonProps={{
                    className: 'ud-link-underline ud-link-neutral',
                    disabled: isCouponFormDisabled,
                }}
            />
        </div>
    );
});
